import { __assign } from "tslib";
import { Path } from '../../enums/marketplace-enums';
import { composer } from '../../component-decorators/composer';
import { SidebarDivider, SidebarSectionTitle, } from 'wix-style-react';
import { MenuItem } from '../menu-item';
import * as React from 'react';
function getPathByType(sectionType) {
    switch (sectionType) {
        case 'categoriesList':
            return Path.CATEGORY;
        case 'collectionsList':
            return Path.COLLECTION;
        default:
            return Path.HOME;
    }
}
export var MenuSection = composer()
    .withExperiments()
    .withTranslation()
    .compose(function (_a) {
    var id = _a.id, type = _a.type, sectionData = _a.sectionData, menuIndex = _a.menuIndex, experiments = _a.experiments, t = _a.t;
    var _b = sectionData === null || sectionData === void 0 ? void 0 : sectionData.tagData, displayName = _b.displayName, tagsToWebSolutions = _b.tagsToWebSolutions;
    var showHolidaySale = experiments.enabled('specs.marketplace.blackFridaySale');
    return (React.createElement(React.Fragment, null,
        React.createElement(SidebarDivider, null),
        React.createElement(SidebarSectionTitle, { dataHook: id + "-menu-section" }, displayName),
        menuIndex === 0 && showHolidaySale && React.createElement(PreHolidaySale, null), tagsToWebSolutions === null || tagsToWebSolutions === void 0 ? void 0 :
        tagsToWebSolutions.map(function (menuItemData, itemIndex) {
            var _a = menuItemData.tag, name = _a.name, slug = _a.slug;
            var path = getPathByType(type);
            var props = {
                itemIndex: itemIndex,
                // index: itemIndex + menuIndex,
                name: name,
                slug: slug,
                path: path,
            };
            // tslint:disable-next-line:jsx-key
            return React.createElement(MenuItem, __assign({}, props));
        })));
});
var PreHolidaySale = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return (React.createElement(MenuItem, { path: Path.CATEGORY, name: t('home.sideMenu.holidaySale'), slug: 'pre-holiday-sale', index: '', holidayColor: true }));
});
//# sourceMappingURL=menu-section.js.map